import awsConfig from '../../../aws-exports';
import { getJwtToken } from '../Auth/JwtHelper';

export const fetchAppConfigByProfileName = async (configProfileName: string): Promise<string | null | void> => {
	const jwtToken = await getJwtToken();

	const result = fetch(awsConfig.appconfig_url, {
		method: 'POST',
		body: JSON.stringify({
			//eslint-disable-next-line @typescript-eslint/no-explicit-any
			configProfileName: awsConfig[configProfileName as keyof Record<string, any>]
		}),
		headers: {
			Authorization: `Bearer ${jwtToken}`,
			'Content-Type': 'application/json'
		}
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.message) {
				return data.message as string;
			}
		})
		.catch((err) => {
			// eslint-disable-next-line no-console
			console.error('fetch appconfig_url failed', err);
		});

	return result;
};
